<div class="mat-container">
  <app-navbar></app-navbar>
  <div class="content-wrapper">
    <app-nav></app-nav>
    <div class="outlet">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
